export const SHOW = `@MODAL/SHOW`;
export const HIDE = `@MODAL/HIDE`;

export const showModal = (modalType, modalProps) => ({ type: SHOW, modalType, modalProps });

export const hideModal = () => ({ type: HIDE });
